
/**
 * Register all common Vue directives here.
 */
import MobileInput from './directives/MobileInput'
Vue.directive('mobile-input', MobileInput)

import infiniteScroll from 'vue-infinite-scroll';
Vue.use(infiniteScroll)

import focus from './directives/Focus'
Vue.directive('focus', focus)



// WEBPACK FOOTER //
// ./resources/assets/js/directives.js